<template>
  <section v-if="text" >
    <v-container grid-list-xl>
      <div class="pa-1">
        <v-sheet border class="fr-view" v-html="text"/>
      </div>
    </v-container>
  </section>
</template>
<script>

import "../../scss/components/froala_style_om.scss"

export default {
  name: "LandingText",
  props: ["text"],
};
</script>
